import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {HttpClient} from "@angular/common/http";
import {of, switchMap} from "rxjs";
import {FintechService} from "../../../services/fintech.service";
import {countries} from "../../../common";

@Component({
  selector: 'app-fintech-shipping',
  templateUrl: './fintech-shipping.component.html',
  styleUrl: './fintech-shipping.component.scss'
})
export class FintechShippingComponent implements OnInit {

    showShippingInfo = false;
    shipForm: FormGroup;

    shippingInfo;

    country;
    m_countries = countries;

    constructor(public fintechService: FintechService,
                private http: HttpClient,
                private formBuilder: FormBuilder) {
        this.shipForm = this.formBuilder.group({
            shipCompany: ['', [Validators.required, Validators.minLength(2)]],
            shipFirstName: ['', [Validators.required, Validators.minLength(2)]],
            shipLastName: ['', [Validators.required, Validators.minLength(2)]],
            shipAddress1: ['', [Validators.required, Validators.minLength(2)]],
            shipAddress2: ['', [Validators.required, Validators.minLength(2)]],
            shipCity: ['', [Validators.required, Validators.minLength(2)]],
            shipState: ['', [Validators.required, Validators.minLength(2)]],
            shipCountry: ['', [Validators.required, Validators.minLength(2)]],
            shipZipCode: ['', [Validators.required, Validators.minLength(2)]],
            shipPhone1: ['', [Validators.required, Validators.minLength(2)]],
            shipPhone2: ['', [Validators.required, Validators.minLength(2)]],
            shipEmail: ['', [Validators.required, Validators.minLength(2)]]
        });
        this.fintechService.notify$.subscribe( msg => {
            if (this.fintechService.data.shippingInfo != null) {
                this.shippingInfo = this.fintechService.data.shippingInfo;

                if (this.fintechService.data.paymentInfo == null) {
                    this.showShippingInfo = true;
                }
            }
        });

        this.fintechService.busy$.subscribe( busy => {
            if (busy) {
                this.shipForm.disable();
            } else {
                this.shipForm.enable();
            }
        });
    }


    ngOnInit(): void {

    }


    onEditShipping() {
        this.shipForm.get('shipCompany').patchValue(this.shippingInfo?.company, {emitEvent: false});
        this.shipForm.get('shipFirstName').patchValue(this.shippingInfo?.firstName, {emitEvent: false});
        this.shipForm.get('shipLastName').patchValue(this.shippingInfo?.lastName, {emitEvent: false});
        this.shipForm.get('shipAddress1').patchValue(this.shippingInfo?.address1, {emitEvent: false});
        this.shipForm.get('shipAddress2').patchValue(this.shippingInfo?.address2, {emitEvent: false});
        this.shipForm.get('shipCity').patchValue(this.shippingInfo?.city, {emitEvent: false});
        this.shipForm.get('shipState').patchValue(this.shippingInfo?.state, {emitEvent: false});
        this.shipForm.get('shipCountry').patchValue(this.shippingInfo?.country, {emitEvent: false});
        this.shipForm.get('shipZipCode').patchValue(this.shippingInfo?.zipCode, {emitEvent: false});
        this.shipForm.get('shipPhone1').patchValue(this.shippingInfo?.phone1, {emitEvent: false});
        this.shipForm.get('shipPhone2').patchValue(this.shippingInfo?.phone2, {emitEvent: false});
        this.shipForm.get('shipEmail').patchValue(this.shippingInfo?.email, {emitEvent: false});


        this.fintechService.editMode = "shipping";
    }

    onCancelShip() {
        this.fintechService.editMode = "info";
    }

    onShipCountry() {
        this.shippingInfo.country =  this.shipForm.value.shipCountry;
    }

    onUpdateShipping() {
        this.fintechService.setBusy(true);

        this.shippingInfo.company =  this.shipForm.value.shipCompany;
        this.shippingInfo.firstName =  this.shipForm.value.shipFirstName;
        this.shippingInfo.lastName =  this.shipForm.value.shipLastName;
        this.shippingInfo.address1 =  this.shipForm.value.shipAddress1;
        this.shippingInfo.address2 =  this.shipForm.value.shipAddress2;
        this.shippingInfo.city =  this.shipForm.value.shipCity;
        this.shippingInfo.state =  this.shipForm.value.shipState;
        this.shippingInfo.country =  this.shipForm.value.shipCountry;
        this.shippingInfo.zipCode =  this.shipForm.value.shipZipCode;
        this.shippingInfo.phone1 =  this.shipForm.value.shipPhone1;
        this.shippingInfo.phone2 =  this.shipForm.value.shipPhone2;
        this.shippingInfo.email =  this.shipForm.value.shipEmail;


        const obs$ = this.fintechService.getPayerToken().pipe(
            switchMap(payerToken => {
                const options: any = {
                    token: payerToken,
                    company: this.shippingInfo.company,
                    firstName: this.shippingInfo.firstName,
                    lastName: this.shippingInfo.lastName,
                    address1: this.shippingInfo.address1,
                    address2: this.shippingInfo.address2,
                    city: this.shippingInfo.city,
                    state: this.shippingInfo.state,
                    country: this.shippingInfo.country,
                    zipCode: this.shippingInfo.zipCode,
                    phone1: this.shippingInfo.phone1,
                    phone2: this.shippingInfo.phone2,
                    email: this.shippingInfo.email
                };
                const url = "https://pay.signage.me:8443/fintech/updateShippingInfo";
                return this.http.post(url, options);
            }),
            switchMap(ret => {
                this.fintechService.editMode = "info";
                this.fintechService.setBusy(false);
                return of('a');
            })
        );
        obs$.subscribe();
    }

    onCopyFromBilling() {
    }
}
